import { SCANNED_INVOICE } from "../../types/Invoice/Invoice";

// eslint-disable-next-line
export const scannedInvoice = (invoice: any) => {
  return {
    type: SCANNED_INVOICE,
    payload: invoice
  };
};
